import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '@/lib/utils'

import { Badge, Barcode, type badgeVariants } from '@/components/ui'

const barcodeBadgeVariants = cva('flex items-center gap-2', {
  variants: {
    size: {
      default: 'text-sm',
      md: 'text-[11px]',
      lg: 'text-base',
    },
  },
  defaultVariants: {
    size: 'default',
  },
})

interface BarcodeBadgeProps
  extends React.ComponentPropsWithoutRef<'div'>,
    VariantProps<typeof barcodeBadgeVariants> {
  badge?: VariantProps<typeof badgeVariants> &
    React.ComponentPropsWithoutRef<'div'>
}

export const BarcodeBadge = ({
  children,
  badge,
  size,
  className,
}: BarcodeBadgeProps) => {
  const { className: badgeClassName, ...restBadge } = badge ?? {}
  return (
    <div className={cn(barcodeBadgeVariants({ size }), className)}>
      <Badge
        className={cn('p-0', badgeClassName)}
        size={size}
        variant="outline"
        {...restBadge}
      >
        <Barcode className="h-3 shrink-0" />
      </Badge>
      <span className={cn('font-mono font-medium')}>{children}</span>
    </div>
  )
}
